export const TRAFFIC_LAYER_URL =
  'https://traffic.arcgis.com/arcgis/rest/services/World/Traffic/MapServer';
export const NA_TRAFFIC_LAYER_NAME = 'North America';
